import { useTranslation } from '../i18n/LanguageContext'
import { termsData, type Lang } from './termsData'

export default function TermsContent() {
  const { language } = useTranslation()
  const lang = (language as Lang) in termsData ? (language as Lang) : 'es'
  const { effectiveDate, intro, sections } = termsData[lang]

  return (
    <>
      <p style={s.effectiveDate}>{effectiveDate}</p>
      <p style={s.intro}>{intro}</p>
      {sections.map((sec) => (
        <section key={sec.heading} style={s.section}>
          <h2 style={s.sectionHeading}>{sec.heading}</h2>
          {sec.body.map((para, i) => (
            <p key={i} style={s.para}>{para}</p>
          ))}
        </section>
      ))}
    </>
  )
}

const s: Record<string, React.CSSProperties> = {
  effectiveDate: {
    fontSize:    '0.875rem',
    color:       '#6B7280',
    marginBottom:'1.25rem',
  },
  intro: {
    fontSize:    '1.125rem',
    color:       '#374151',
    lineHeight:  1.7,
    marginBottom:'2rem',
  },
  section: {
    marginBottom: '1.75rem',
  },
  sectionHeading: {
    fontSize:    '1.0625rem',
    fontWeight:  700,
    color:       '#1B4332',
    marginBottom:'0.5rem',
  },
  para: {
    fontSize:    '1rem',
    color:       '#374151',
    lineHeight:  1.7,
    marginBottom:'0.75rem',
  },
}
